import { PARTNER_TYPES } from '../../partner-types';
import { Roles } from '../../roles';
import { MenuItem } from '../types';

export const userManagementSection: MenuItem[] = [
  {
    headTitle1: 'User Management',
    type: 'headtitle',
  },
  {
    title: 'Users',
    icon: 'stroke-user',
    iconf: 'fill-user',
    type: 'sub',
    active: false,
    children: [
      {
        path: '/users/profile',
        title: 'My Profile',
        type: 'link',
        active: false,
      },
      {
        path: '/users/edit',
        title: 'Edit User',
        type: 'link',
        active: false,
      },
      {
        path: '/users/list',
        title: 'All Users',
        type: 'link',
        active: false,
        requiredRoles: [Roles.userManagementAdmin],
      },
      {
        path: '/users/create',
        title: 'Add User',
        type: 'link',
        active: false,
        requiredRoles: [Roles.userManagementAdmin],
      },
      {
        path: '/users/guide',
        title: 'User Management Guide',
        type: 'link',
        active: false,
        requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
      },
      {
        path: '/profile/security',
        title: 'Security & 2FA',
        type: 'link',
        active: false,
      },
    ],
  },
  // Partner Administration lives in its own top-level menu section now —
  // see `partner-administration.ts` (which also hosts Partner Onboarding).
];
